import Flex from '@components/Flex/Flex';
import {
  Container,
  StyledLogoContainer,
  StyledLogo,
  Subtitle,
  Title,
} from './InfoCard.styles';

interface InfoCardProps {
  title: string;
  subtitle: string;
  icon: string;
}

const InfoCard: React.FC<InfoCardProps> = ({ title, subtitle, icon }) => {
  return (
    <Container>
      <>
        <StyledLogoContainer>
          <StyledLogo src={icon} />
        </StyledLogoContainer>
        <Flex flexDirection='column'>
          <Title variant='h6' fontWeight='fontWeightMedium'>
            {title}
          </Title>
          <Subtitle variant='h5' fontWeight='fontWeightSemiBold'>
            {subtitle}
          </Subtitle>
        </Flex>
      </>
    </Container>
  );
};

export default InfoCard;
